import { SEVERITY_EMOJI, type Severity } from '@ixam/shared';

const STYLES: Record<Severity, string> = {
  critical: 'bg-sev-critical-soft text-sev-critical border-sev-critical/30',
  warning: 'bg-sev-warning-soft text-sev-warning border-sev-warning/30',
  info: 'bg-sev-info-soft text-sev-info border-sev-info/30',
  ok: 'bg-sev-ok-soft text-sev-ok border-sev-ok/30',
};

const LABEL_IT: Record<Severity, string> = {
  critical: 'critico',
  warning: 'attenzione',
  info: 'info',
  ok: 'ok',
};

export function SeverityBadge({ severity }: { severity: Severity }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium rounded-md border ${STYLES[severity]}`}
    >
      <span aria-hidden>{SEVERITY_EMOJI[severity]}</span>
      <span>{LABEL_IT[severity]}</span>
    </span>
  );
}
